<template>
	<vxe-modal v-model="showFlag" title="配表分析" :destroy-on-close="true" show-zoom resize
					fullscreen remember :esc-closable="true" :mask="false":lock-view="false">
		<a-layout  style="padding: 0;">
			<a-layout-sider   width="240" theme="light" class="mySider">
				<a-directory-tree multiple default-expand-all @select="onSelect"  :defaultSelectedKeys="checkedMonitor">
					<a-tree-node key="0" :title="myTitle" style="color: white;">
					      <a-tree-node  v-for="(item,index) in dataList" 
								:key="item.meterId" is-leaf  :title="item.monitorName"/>
					</a-tree-node>
				</a-directory-tree>
			</a-layout-sider>
			<a-layout-content style="background-color: white;padding: 0.625rem;">
				<div class="actDiv">
					<label style="font-size: 0.8rem;">时间区间：</label>
					<a-range-picker disabled  style="font-size: 0.6875rem;width: 15rem;" v-model="theDateList" format="YYYY-MM-DD" @change="onChangeDate" size="small">
					</a-range-picker>
					<a-button size="small"   icon="search" @click="doQuery" style="margin: 0 0.5rem;" :loading="loading">查询</a-button>
				</div>
				<div id="mChart"></div>
			</a-layout-content>
		</a-layout>
	</vxe-modal>
</template>

<script>
	import * as echarts from 'echarts';
	export default {
		data(){
			return {
				loading:false,
				showFlag:false,
				checkedMonitor:[],
				statisList:[],
				dataList:[],
				dateStart:null,
				dateEnd:null,
				theDateList:null,
				mChart:null,
				
			}
		},
		methods: {
			getTheCheckMonitor(){
				var result = null;
				let checkedMeter = this.checkedMonitor[0];
				for(var i=0;i<this.dataList.length;i++){
					let item = this.dataList[i];
					if(checkedMeter == item.meterId){
						result = item;
						break;
					}
				}
				return  result;
			},
			showView(meterIdList){
				this.checkedMonitor = meterIdList;
				if(this.showFlag == false){
					this.showFlag = true;
				}
				this.dateStart = this.$moment().subtract(1,'month').format('YYYY-MM-DD');
				this.dateEnd = this.$moment().format('YYYY-MM-DD');
				this.theDateList = [this.dateStart,this.dateEnd];
				this.doQuery();
			},
			onChangeDate(date, dateString) {
				this.dateStart=dateString[0];
				this.dateEnd=dateString[1];
			},
			doQuery(){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_ANALYSIS_URL);
				let param = {
					meterId:this.checkedMonitor[0],
					beginDate:this.dateStart,
					endDate:this.dateEnd,
				};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.statisList =result.reverse();
						this.initCharts();
						this.drawEcharts();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			onSelect(keys, event){
				this.showView(keys);
			},
			getMeterMonitorList4Map(){
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_MAP_INFO_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			initCharts(){
				let a = window.document.getElementById("mChart");
				this.mChart = echarts.init(a);
			},
			drawEcharts(){
				let theMeter = this.getTheCheckMonitor();
				var xData = [];
				var flowData = [];
				var maxData = [];
				var minData  = [];
				for(var i=0;i<this.statisList.length;i++){
					let item = this.statisList[i];
					flowData.push(item.intervalFlow);
					maxData.push(item.maxFlow);
					minData.push(item.minFlow);
					xData.push(item.readTime);
				}
				var option = {
					title:{
						text:theMeter.monitorName,
						left:'center',
					},
					grid:{
						bottom:135
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							animation: false
						}
					},
					legend: {
						data: ['瞬时流量', , '最大流量', '最小流量'],
						x:'center',
						y:'bottom',
					},
					xAxis: {
						type: 'category',
						data:xData,
					},
					yAxis: {
						type: 'value',
						name:'瞬时流量',
					},
					series: [
						{
							name: '瞬时流量',
							type: 'line',
							smooth: true,
							symbolSize:8,
							data:flowData,
						},
						{
							name: '最大流量',
							type: 'line',
							data: maxData,
							smooth: true,
							itemStyle:{
							 	color:"#5C7BD9"
							}
						},
						
						{
							name: '最小流量',
							type: 'line',
							data: minData,
							smooth: true,
							itemStyle:{
							 	color:"#9FE080"
							}
						},
					],
				};
				this.mChart.setOption(option);
			},
		},
		computed:{
			myTitle:function(){
				let a = this.dataList.length;
				return "监控表("+a+")";
			},
		},
		created() {
			this.getMeterMonitorList4Map();
		},
	}
</script>

<style>
	#mChart{
		width: 100%;
		height: 680px;
	}
</style>
